// prettier-ignore
export default {
  generic: {
    network_error: '無法連接伺服器<br>請檢查您的網路連線',
    network_restored: '網路連線已恢復',
    bluetooth_error: '藍芽連線中斷<br>掃描過程中請將您的裝置靠近掃描機，並確保藍芽訊號強度足夠',
    permisson_device_orientation_not_allowed: '為了使用方向感應功能，建議您重新啟動瀏覽器以重新詢問權限。<br>或是確認手機與地面垂直90度後點擊下一步。',
    permisson_device_orientation_not_support: '很抱歉，您的瀏覽器不支援方向感應功能。建議您嘗試使用其他瀏覽器或裝置。<br>或是確認手機與地面垂直90度後點擊下一步。',
  },
  terms: {
    terms: "TG3D Studio Inc. Limited 及其關係企業（以下簡稱本公司）依據本服務條款（以下簡稱本條款）提供Cloudzet™自助式人體掃描及其相關服務（以下簡稱本服務）。<br><br>當您註冊成為用戶時，即視為您已閱讀本條款並同意受其及相關法律之約束。當您使用本公司所提供服務及軟體時，其附加條款或規定即成為您與本公司所訂協議的一部分。若您為未成年人，除您本人應遵守本條款規定外，並應請您父母親（或監護人）同時確實閱讀、瞭解並同意遵守本條款之所有內容，您方得開始下載或使用服務與軟體。 <br><br>當您於本條款為修改或變更後仍繼續使用服務與軟體時，即推定您或（及）您的父母親（或監護人）已閱讀、暸解、並同意本條款修改後之內容。<br><br>一、服務介紹 <br><br>本服務的Cloudzet™自助式人體掃描APP及自動掃描設備，可掃描用戶之身體體型數據（掃描量體數據），並產生人體3D模型，（二者合稱3D數據檔案）。用戶若於第三方商店使用本服務，第三方商店可使用用戶之3D數據檔案，以提供用戶服裝訂製服務及（或）品牌服裝推薦服務；本公司亦將透過本服務，推薦用戶各式品牌服裝。所有服裝由第三方商店提供，用戶向第三方訂購服裝應自行審視服裝材質、尺寸、剪裁、訂製、交件等相關訊息，以確保其購買權益。<br><br>二、定義 <br><br>1.軟體：係指包括本公司及／或其關係企業所開發的Cloudzet™ App軟體、所有的更新版本以及任何本公司以後所提供的輔助或附加應用程式或軟體。 <br><br>2.用戶：係指所有同意本條款內容，並完成用戶註冊程序的使用者。 <br><br>3.3D數據檔案：透過本服務產出之人體三維數據檔案，包含人體3D模型及掃瞄量體數據。 <br><br>4.人體3D模型：係指以3D形式顯示之人體原始採集資訊。 <br><br>5.掃描量體數據：係指透過本服務所取得之用戶身體可測量之圍度與長度數據，包括但不限於頸圍、胸圍、腰圍、臀圍等。 <br><br>6.第三方商店：係指於本服務內可提供用戶服裝訂製及（或）銷售服務之廠商及其網站／APP。<br><br>三、用戶帳號註冊 <br><br>1.本服務得以手機號碼、電子郵件為用戶帳號。用戶註冊時應提供手機號碼或電子郵件及註冊流程中所要求之其他相關資料（如：姓名及性別）以完成各項認證，並使用本服務之所有功能。 <br><br>2.本服務亦得以微信或Facebook帳號密碼登入本服務。<br><br>四、用戶責任與義務 <br><br>1.真實資料義務 <br><br>您同意於註冊時填寫您正確、完整且符合真實之個人資料。您所登錄之資料若事後有所變更時，可隨時於線上更新。您所填寫的個人資料如有不符合真實，或原填寫之資料已不符合真實而未更新，或有任何誤導之嫌，本公司擁有隨時終止您用戶資格及使用本服務之權利。如您提供資料為非本人或錯誤資訊，致第三方商店無法聯繫或造成第三人權益之損害時，將自負相關法律及／或損害賠償責任。<br><br>2.帳號保管義務 <br><br>a.用戶帳號僅限用戶本人使用，不得提供其他第三人使用。 <br><br>b.用戶有義務妥善保管註冊帳號、密碼及其他相關資訊，以此組註冊帳號登入系統後所進行之一切活動，均視為用戶本人之行為。 <br><br>c.若用戶發現註冊帳號內個人資料遭他人非法使用或有任何異常使用之情形時，應立即通知本公司，並循適當法律途徑保護自身權益；必要時，本公司會請用戶提供相關個人資料，並有權未經通知而暫停該爭議帳戶之使用權限。 <br><br>d.如因用戶保管疏忽或同意由第三人使用其帳號，導致用戶帳號、密碼遭他人非法使用，造成本公司或其他用戶權益損害時，將自行負責相關法律及／或損害賠償責任。<br><br>五、人體3D數據之蒐集 <br><br>當您註冊或是使用本服務時，即代表您同意本公司為提供TG3DsCloudzet™自助式人體掃描本服務而蒐集您的掃描量體數據以及人體3D模型。<br><br>六、軟體授權及限制 <br><br>1. 本公司授權您使用軟體，但您必須確實遵守本條款及各項軟體及服務之附加條款，如有任何違反情形，經本公司察覺後，可不經通知逕行中止或終止您使用軟體的權利。 <br><br>2. 本公司授權您使用軟體進行自助式人體掃描服務及其他本公司相繼開發之服務，但您不得更改、再授權、出租、銷售、或以任何非本條款授權之方式使用軟體。您並同意遵守所有相關法令，即只為合法目的而使用軟體。 <br><br>3. 本公司僅授權您使用軟體，所有軟體及相關編碼程式之智慧財產權仍屬本公司所有。用戶不可對軟體進行任何修改、還原工程、反向編碼、簡化為常人可理解形式或反向組譯、阻止或妨礙其他用戶享受軟體與服務、藉軟體與服務而散播病毒或其他足以損害他人電腦運作之程式、違反本條款的軟體或內容、及任何可能侵害他人智慧財產權或其它權益之內容。 <br><br>4. 本公司得採取任何必要的手段，防止您以本條款或相關法令所禁止的方式使用軟體與服務。<br><br>七、隱私權政策<br><br>相關隱私權說明，請參考隱私權政策。<br><br>八、智慧財產權 <br><br>1.本公司僅授權您使用服務及軟體，而並非將本公司所提供的服務、軟體及任何編碼的著作權移轉給您。為免存疑，一切本公司沒有在本條款中明確授予您的權利，均由本公司保留。 <br><br>2.您承認本公司之服務、內容、軟體及技術受各授權地區相關法令保護，並同意不會移除或變更服務及軟體中所包含的任何著作權權利電子管理資訊、防盜拷措施或其它權利（包括且不限於專利權、商標權）或軟體的標記。<br><br>九、責任限制 <br><br>1.本公司對於透過軟體與服務而提供的任何資訊、內容、軟體或服務，均僅依各該服務當時之功能及現況提供使用。就連線中斷、延遲或與通訊相關缺陷，本公司對服務形式或內容不負任何擔保或保證責任。 <br><br>2.除法律明文禁止外，在任何情況下，本公司不對任何損失負損害賠償的責任，包括因使用或無法使用軟體或服務而引起的損失，或其它直接、間接、意外、特別或因應性的損失(包括但不限於生意盈利的損害或遺失、生意中斷、生意資訊的遺失、和任何其它金錢上的損失)。 <br><br>3.本公司對於用戶因第三方商店及其他用戶或其他使用者的故意或過失所造成的任何瑕疵與損害，不負擔保與賠償之責。 <br><br>4.用戶使用本服務時，如與第三方商店或品牌服飾廠商之交易發生糾紛時，本公司不負任何擔保或賠償責任。<br><br>十、使用條款修改 <br><br>本公司保留隨時修改本條款的權利。當本公司將修改後的用戶使用條款內容於本公司網站上公布以後，您繼續使用本軟體與服務的行為即代表您已接受此修改。<br><br>十一、準據法與管轄法院 <br><br>1.本條款之解釋、補充及適用均以中華民國法令為準據法。如有未盡事宜，請聯繫本公司。 <br><br>2.倘本條款之中文版與英文版有差異時，以中文版為準。您與本公司雙方都同意所有因本條款所產生的爭議若無法協調解決而需訴訟時，都以台灣台北地方法院 為第一審的管轄法院。",
    privacy: "TG3D Studio Inc. Limited 及其關係企業 （以下簡稱本公司）重視用戶的個人隱私，並遵循保護隱私權及個人資料之相關法令規定。以下是本公司之隱私權政策（以下稱「本政策」），將說明本公司會收集哪些個人資料與如何使用這些資料，並說明其他與您的隱私相關的重要事項。<br><br>1.當您註冊成為Cloudzet™ 自助式人體掃描服務之用戶時，會要求您輸入註冊帳號（手機號碼或電子郵件信箱）、姓名、性別以及生日。<br><br>2.當您透過微信或 FACEBOOK 帳戶（以下簡稱「第三方網站」）註冊成為本服務用戶時，您同意本公司蒐集您的身分驗證資料以及在您的第三方網站帳號上可以看到或透過您的第三方網站帳號可以找到的其他資料，包括您的姓名、個人資料圖片、國家、電子郵箱地址、出生日期、性別、朋友的姓名及其個人資料圖片和交友網絡等。本公司可能需要驗證您的資料是否與該第三方網站上的資料一致及/或依照本政策利用該等資料。<br><br>3.當您在使用本服務時，本公司可能會蒐集下列資訊： <br><br>(1)您的掃描量體數據及人體3D模型，以及身高、體重以及地址。 <br><br>(2)您的使用資料，包括但不限於相機、相片、SD卡內容 等； <br><br>(3)技術數據，例如：URL、IP 地址、瀏覽器類型、作業系統資料、語言及造訪時間等。本網站及軟體將會透過Google Analytics分析工具來蒐集前述資料，相關Google Analytics(分析)隱私權政策與如何拒絕向Google Analytics(分析)透露資訊，您可直接前往Google Analytics(分析)資料隱私權與安全性網頁瀏覽進行瞭解。若您不願意向Google Analytics(分析)透露資訊，您可以下載Google Analytics (分析) 不透露資訊瀏覽器外掛程式。<br><br>4.本公司為提供您正確與快速的服務，當您使用本服務時，如: 商品訂購、帳戶異動、意見回饋或參與產品行銷活動，會請您提供用戶帳號資料或個人聯繫方式。<br><br>5.本公司蒐集到的資訊，將用於以下用途： <br><br>(1)您所提供的基本個人資料（如姓名），將作為本公司或第三方商店作為用戶身分判定的依據；您所提供的聯繫方式，將作為本公司或第三方商店用以聯絡、行銷活動通知、通知繳費、活動中獎通知、扣款通知、寄送發票、提供個人化品牌服飾推薦、或其他與本服務相關更新通知。 如果您不想收到任何行銷簡訊或是電子郵件，請聯繫 support@tg3ds.com。<br><br>(2)您的3D數據數據，將作為第三方商店為您訂製服裝或建議成衣尺寸之用，或由本公司推薦各品牌成衣。 <br><br>(3)您因使用本服務所產生之資訊，包含3D數據檔案、使用資料及技術資料等，將作為改進本服務或開發新服務用。<br><br>(4)我們將以推播的方式提供您我方及任何第三方之行銷資訊及廣告。若您不願意再收到此類的推播訊息，或是原本於註冊時您雖同意本服務可接觸您的相機、相片及SD卡之資料，但嗣後決定欲停止此利用，您可透過您的裝置本身之功能設定停止前述使用。<br><br>6.您明白且同意本公司可能與第三方共用綜合性的非個人資料。綜合性非個人資料是指記錄有關用戶的資料已經過分類或編輯後不再反映或指向某個特定的可被辨識的使用者之資料。<br><br>7.上述資訊之處理與利用，可能由本公司之關係企業或其他合作夥伴進行，或於台灣外發生。除非有當地法律除外情況，本公司不會將這些資訊用做其他用途。本公司亦不會未經用戶事先同意向第三者透露其個人資料，但因國家重大利益或為配合執法機關調查而根據法律而需要透露者則除外。<br><br>8.您本人可查詢、複製或申請變動屬於您個人資料範圍，若非本人或於本公司尚未查證您為本人前，您不得申請查詢、複製、請求閱覽或申請變動不屬於本帳號之個人資料及帳號服務。如非前述情況之申請者，必要時您將提供相關個人資料及書面資訊，使本公司可協助處理作業程序。<br><br>9.您本人可要求停止利用或刪除屬於您的個人資料；但一經停止或刪除，您將無法繼續使用 本服務，並可能影響您與第三方商店之交易。<br><br>10.即使您要求刪除屬於您的個人資料，您不可撤回地同意本公司仍得保留綜合性之個人資料，以改進本服務及相關技術或開發新服務用。<br><br>11.於妨害國家重大利益、妨害公務機關執行法定職務、妨害蒐集機關或第三人重大利益時，本公司有權拒絕您主動提出變更、刪除或異動個人資料之請求。<br><br>12.為保護您的隱私，本公司提供必要之技術及措施保護個人資料。<br><br>13.您的個人資料、註冊帳號及密碼等，請您妥善保管，避免外洩。於個人或非個人電腦上使用本服務時，必要時請登出或關閉軟體與瀏覽器視窗，以免您的資料遭人盜用。<br><br>14.您的付費資訊(含信用卡資料)，請您妥善保管，避免為他人之不法用途。<br><br>15.本服務均有可能包含其他非本公司網站或網頁連結，若您個人同意該網站蒐集、處理或利用您的個人資料，本公司不負任何連帶責任。<br><br>16.您同意在本服務進行之消費時所留存的資料與事實相符，如嗣後發現你的個人資料遭他人非法使用或有任何異常時，應即時通知本公司。<br><br>17.您同意於使用本服務時，所提供及使用之資料皆為合法，並無侵害第三人權利、違反第三方協議或涉及任何違法行為。如因使用服務而致第三人損害，除本公司故意或重大過失外，本公司並不負擔相關賠償責任。<br><br>18.本公司將不定時更新本政策，並遵循當地隱私權與個人資料保護相關法令，當本公司做出重大修改時，會於官方網站 (http://www.tg3ds.com) 或APP公布。<br><br>19.本政策構成服務條款的一部分。如您不同意本政策之任何條款或修改變更之內容，請您立即停止使用服務。<br><br>20.如果您對本公司的隱私權或個人資料保護政策有任何問題，請聯絡 suppot@tg3ds.com",
  },
  login: {
    cloudzet_welcome: '嗨！歡迎來到雲衣適',
    mtm_username: 'Scanatic™ 帳號',
    password: '密碼',
    login: '登入',
    logging_in: '登入中',
    no_login_methods: '無法使用此 Scanatic™ 帳號登入',
    agreements_button: '同意並繼續',
    complete_email_reset_pwd_title: '交給我們！',
    sent_email: '我們已發送密碼變更認證信至',
    email_reset_pwd: '請按照郵件中的指示，即可重設密碼',
    get_the_code: '沒有收到認證碼？',
    resend: '重新發送',
    complete_phone_reset_pwd_title: '恭喜您！',
    login_new_password: '您已成功設置了新密碼，請使用新設置的密碼登入帳號',
    login_my_account: '登入帳號',
    sent_a_code: '我們已發送認證碼至',
    received_code: '是否有收到？',
    verification_code_error: '認證碼有誤',
    continue: '繼續',
    forget_your_password: '忘記密碼？',
    forget_password_text: `別擔心！`,
    send: '發送',
    submit: '送出',
    no_such_user: '查無帳號',
    email_prompt_text: '我們會將密碼更變認證信發送至您的信箱',
    phone_prompt_text: '我們會將四位數的認證碼發送至您的手機',
    login_title: '歡迎回來！',
    login_email_title: '使用電子郵箱登入',
    login_phone_title: '使用手機號碼登入',
    forget_password: '忘記密碼？',
    terms_of_service: '服務條款',
    choose_a_country_code: '選擇國家區域碼',
    choose_a_country_code_hint: '登入/註冊僅限以下國家或地區',
    country_code_not_found: '找不到您的國家區域碼？',
    sign_up_email: '使用電子郵箱註冊',
    email_sign_up_error_msg: '請輸入正確的電子郵箱',
    four_characters: '您的密碼必須至少要有四個字元',
    try_to_login: '此帳號已被註冊，請選擇直接登入',
    try_use_email: '嘗試使用您的電子郵件',
    sign_up: '註冊',
    sent_verification_code: '我們會將四位數的認證碼發送至您的手機',
    sign_up_phone: '使用電話號碼註冊',
    sign_up_store: '使用店家註冊',
    set_up_new_pwd: '請設置您的密碼',
    set_up_new_password: '請設置您的密碼',
    set_new_pwd: '設置新的密碼',
    enter_country_code: '輸入國家區域碼',
    enter_email_address: '輸入您的電子郵件',
    enter_phone_number: '輸入您的電話號碼',
    customer_account_name: '客戶帳號名稱',
    enter_password: '輸入密碼',
    re_enter_password: '重新輸入密碼',
    login_social_accounts: '使用社群帳號註冊',
    social_login_failed: '使用社群帳號登入失敗',
    login_first: '請先登入',
    create_with_store: '店家建立',
    verify: '確認',
    welcome_to_store: '歡迎來到 {storeName}！',
    login_to_continue: '登入/ 註冊以繼續',
    wrong_password: '密碼錯誤，請確認密碼',
  },
  stamp: {
    tap_to_start: 'スキャン開始手順を読み<br>準備ができたら、タップしてください',
    tap_camera_on: '指でタップしてカメラを起動',
    welcome_title: 'Welcome to<br>STAMP SCAN BOX',
    note_front_camera: 'あなたのスマートフォンを使ってLINE上からSCAN CODEを起動し、前面のカメラにかざしてログインしましょう',
    scan_code_title: '',
    scan_code_hint: 'SCAN CODEを枠内にかざしてください',
    things_to_note_title: 'Before The 3D Body Scan',
    clothes_info: '肌に密着した下着のみになってください<br>衣類はボックスに入れてください',
    clothes_alt_info: '男性のトランクス、女性のブラトップなど、ゆとりのありすぎる衣類では、正常にスキャンできない場合があります',
    accessories_info: 'メガネ以外のアクセサリー類は外してください<br>髪の長い方は首にかからないように結んでください',
    accessories_alt_info: 'ヘアゴムはボックス内に、用意しています',
    touch_for_tutorial: 'スキャンの準備ができたら指でタップ',
    tutorial: {
      title: 'The Contactless Control Tutorial',
      contactless: '3Dスキャンの操作ガイドを始めます',
      clench_fingers: '両手は軽く握り、握り拳を作ります',
      raise_arm: 'マークの位置まで両腕をあげます',
      raise_arm_2: 'マークの位置でセンサーが反応し、スキャンが始まります',
      feet_pos: '足型に合わせて気を付けの姿勢で立ちます',
    },
    choose_to_start: {
      title: '3D Scan Tutorial',
      start: 'マークの位置まで両腕をあげてください',
      done: 'この体制でスキャンが始まります',
    },
    end_goodjob: 'おつかれさまでした',
    end_line: 'LINEスキャンメニューからカメラを起動し、<br>QRコードを読み取ってチェックアウトしましょう',
    choose_step_info: 'マークの位置まで右腕をあげてください',
    clench: '両手は軽く握り、握り拳を作ってください',
    feet_position: '足型に合わせて気を付けの姿勢で立ってください',
    raise_arm: 'マークの位置まで両腕をあげてください',
    hold_left: '左腕を、マークの位置までゆっくりあげてください',
    hold_right: '右腕を、マークの位置までゆっくりあげてください',
    scan_step_name_begin: 'Begin the 3D Body Scan',
    scan_step_name: '3D Body Scan',
    scan_step_name_2: '2nd Time 3D Body Scan',
    scan_body_start: 'マークの位置まで両腕をあげてください',
    scan_in_progress: 'スキャンが始まります<br>そのまま動かないでください',
    scan_complete_1: '1回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい',
    scan_complete_2: '2回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい',
    analyzing: '3Dデータを生成しています',
    leave: 'ログアウト',
    end_next: 'スキャンを終了する',
    end_next_info: 'Next Information',
    end_instruction: '洋服を着て下さい。<br> 続けて、外のタブレットへと移動し、<br> 新たな体験をお楽しみください。',
    scan_again: 'もう一度スキャン',
    scan_unsuccessful: 'スキャンに失敗しました',
    scan_successful: 'スキャンデータの生成に成功しました',
    neck: '首回り',
    chest: 'チェスト',
    chest_female: 'バスト',
    torso: '胴回り',
    mid_waist: 'ウエスト',
    hip: 'ヒップ',
    shoulder: '肩幅',
    biceps: '上腕回り',
    arm: '腕丈',
    thigh: '太もも',
    inner_leg: '股下-地面',
    avoid_errors: 'スキャン時の注意事項を確認してもう一度スキャンしてください',
    error_accessories: 'メガネ以外のアクセサリー類を外してください',
    error_cover_neck: '髪の長い方は首が隠れないよう結んでください',
    error_floor_marks: '足型に合わせて立ってください',
    error_postural: 'スキャン時は姿勢を正してください',
    welcome_steps: 'スキャン開始手順',
    welcome_step_1: '靴と鞄はボックスに入れてください',
    welcome_step_2: 'LINE下部メニューのスキャンコードをタップしQRコードを発行します',
  },
  hm: {
    end_title: 'Thank you!',
    end_text: 'You can now return to the Body Scan Jeans Design Station to customize your jeans.<br>Remember to carry your personal belongings with you.',
  },
  welcome: {
    enable_bt: '開始前，請記得開啟您的藍芽',
    welcome_title: '歡迎來到 3D 掃描室',
    powered_by: 'Powered by TG3D Studio Inc.',
    tap_to_start: '點擊按鈕開始 3D 掃描',
    tap_camera_on: '開啟相機鏡頭掃描二維碼',
    ready_to_scan_qr: '掃描二維碼',
    note_front_camera: '注意：您在掃描二維碼時，前鏡頭將會被開啟',
    scan_code_title: '掃描二維碼並進入掃描流程',
    scan_code_hint: '請將二維碼放入方框中',
    scan_code_processing: '處理中',
    scan_code_logging_in: '帳號登入中',
    scan_code_connect_to_scanner: '掃描機連線中',
    scan_code_no_account: '此帳號不存在，請重新嘗試',
    scan_code_done: '準備開始',
    no_scanner_id: '此 Scanatic™ 帳號並沒有掃描機連結設定',
    no_scanner_found: '搜尋不到掃描機',
    scanner_in_use: '掃描機使用中',
    unexpected_error: '抱歉！出了點問題，請稍後再試',
    need_camera_permission: '您必須同意給予使用相機的權限才能進行此操作',
    share_qr_code: '顯示我的 QR Code',
    my_qr_code: '我的 QR Code',
    scan_qr_code_reminder: '掃描 QR Code 以在其他裝置上登入',
  },
  choose: {
    step_name: '準備好 3D 掃描了嗎？',
    step_info: '準備好後，將手臂舉起，把拳頭放進兩旁的泡泡框中',
    tutorial: '掃描教學',
    start_scan: '3D 掃描',
    clench_fingers: '雙手輕握拳',
    raise_arm: '將手臂舉起至拳頭觸碰到泡泡框',
    hold_til_fill: '停在這個位置，直到泡泡框填滿',
  },
  thingstonote: {
    title: '開始掃描之前',
    wear_tight: '穿著貼身衣物',
    tie_hair: '束起長髮，露出脖子',
    remove_acc: '移除首飾配件',
  },
  scanscreen: {
    skip: '略過說明',
  },
  tutorial: {
    title: 'The Contactless Control Tutorial',
    contactless: 'The contactless experience ensures your health is protected',
    clench_fingers: 'Lightly clench your fingers',
    raise_arm: 'To control the bubbles, please raise your arms until you touch the bubbles and hold for 2 seconds',
    hold: 'Now hold until the bubble is filled',
    proceed: 'To proceed to the next step, raise your right arm until it touches the bubble.',
    return: 'To return to the previous step, raise your left arm until it touches the bubble.',
    feet_pos: 'Position your feet on the floor mat',
  },
  scan: {
    feet_pos: '腳踩定位',
    step_name: '3D 人體掃描',
    phase_one_done: '第一階段掃描完成',
    begin_2nd: '開始第二階段 3D 人體掃描',
    clench: '雙手輕握拳',
    raise_both_arm: '將手臂舉起至拳頭觸碰到泡泡框',
    raise_fists: '位置過低。將您的雙臂繼續張開，直到拳頭完整放入泡泡框中',
    lower_fists: '位置過高。將您的雙臂降下，讓拳頭完整放入泡泡框中',
    hold_still: '請保持手臂静止不動',
    scan_keep_still: '請保持身體静止不動',
    scan_in_progress: '掃描中',
    scan_complete: '掃描完成，請放鬆身體',
    two_step_scan: '掃描將分成兩階段進行',
    raise_elbow: '將手肘向外抬起，以避免手臂在掃描過程中接觸身體',
    scanner_occupied: '掃描室使用中，請確認無人使用，或是重啟掃描主機後重試',
    scanner_error_need_reset: '掃描機有問題，請洽服務人員重啟掃描機後再重試',
    scanner_error_generic: '掃描機有問題，請洽服務人員',
    scanner_not_activated: '掃描室尚未開通，請洽服務人員',
    scanner_check_network: '請洽服務人員確認掃描室是否連線，或重啟掃描主機後重試',
  },
  handles: {
    hold: '雙手輕握手把<br>雙臂放鬆伸直',
    hold_ready: '雙手輕握手把<br>準備掃描',
    letgo_and_keep_feet: '鬆開手把，保持原本站姿<br>直視前方',
    clench_ipose: '雙手輕握拳<br>平行兩側約5公分',
    clench_ready: '雙手輕握拳<br>準備掃描',
  },
  end: {
    thank: '謝謝！',
    belonging: '請穿回衣服並記得帶走您攜帶的物品',
  },
  analyzing: {
    check_err: '3D 化身建立中...',
  },
  result: {
    scan_successful: '太好了！您的 3D 掃描結果十分成功！',
    scan_unsuccessful: '糟糕！我們無法處理您的3D掃描數據',
    avoid_errors: '掃描常見錯誤',
    error_accessories: '戴著手飾項鍊等配件',
    error_cover_neck: '頭髮蓋住脖子',
    error_floor_marks: '雙腳未站定位',
    error_postural: '姿勢錯誤',
    leave: '離開',
    raise: '若想重新掃描，請將手臂舉起至拳頭觸碰到泡泡框',
    scan_again: '重新掃描',
    analyzing: '掃描資料處理中...',
    click_scan_again: '請按下方按鈕再次掃描',
    oops: '糟糕!',
    unexpected_error: '發生了未知的錯誤...',
    close: '關閉',
  },
  measurement: {
    neck: '頸圍',
    chest: '胸圍',
    torso: '後身長',
    mid_waist: '中腰圍',
    hip: '臀圍',
    shoulder: '肩寬',
    biceps: '臂圍',
    arm: '臂長',
    thigh: '大腿圍',
    inner_leg: '內腿長',
    chest_female: '胸圍',
    under_bust: '胸下圍',
    breast_triangle: '胸前三角',
    spine_angle: '脊椎角度',
    breast_volume: '左右胸大小',
    bra_strap: '肩凹',
    pelvic_tilts: '骨盆前移',
    rounded_shoulder: '圓肩',
    neck_to_hip_height: '臀高',
    neck_to_back_depth: '富貴包',
  },
  homePage: {
    firstScanTitle: '開創未來無限可能',
    tap_to_scan: '點擊按鈕進行 3D 掃描',
    measurement: '尺寸',
    body_3d_avatar: '3D 人體',
    see_more: '查看更多',
    menu: '主選單',
    store_settings: '商家設定',
    avatar_shader_3d: '3D 人體材質',
    avatar_shader: '人體材質',
    create_3d_shader: '製作 3D 材質',
    language: '語言',
    get_help: '尋求幫助',
    feedback: '回饋',
    send_feedback: '提供回饋',
    send_btn: '送出',
    send_feedback_placeholder: '您的回饋將會幫助我們優化產品及服務',
    send_feedback_title: '感謝您的意見與回饋',
    send_feedback_content: '我們已將您的意見及回饋記錄下來，您的寶貴建議是我們持續優化產品服務的最大動力，期待未來能夠帶給您更優質的產品體驗。若有更多的回饋意見，請隨時與我們聯繫。',
    report_crash: '回報問題',
    report_crash_title: '感謝您的回報',
    report_crash_content: '很抱歉造成您在體驗上的不愉快，我們的開發團隊會盡快調查問題原因，並嘗試解決。如果您還有遭遇到其他的問題，請隨時與我們聯繫。',
    rate_app: '我愛雲衣適',
    rate_app_title: '在 App Store 評價雲衣適',
    rate_app_content: '若您對於此次的體驗十分滿意，請別吝嗇於 App Store 中給予雲衣適五顆星，謝謝您！',
    login_s4f: '使用 Scanatic™ 帳號登入',
    login: '登入',
    password: '密碼',
    account_settings: '帳號設定',
    enter_Scanatic_account: '輸入 Scanatic™ 帳號',
    logout: '登出',
    delete_account: '刪除帳號',
    confirm_delete: '您確定嗎？',
    contactless_scan: '免觸式感應掃描',
    delete: '刪除',
    cancel_delete: '取消',
    ok: '確定',
    scan_to_login: '掃碼登入',
    history: '掃描記錄',
    view_avatar: '查看掃描記錄',
    select_date: '選擇日期',
    select: '確定',
    analysis: '分析',
    comparison: '比較',
    leftCompareView: '左側模型',
    rightCompareView: '右側模型',
  },
  settingUserData: {
    your_birth: '請問您的出生年份',
    your_gender: '請問您的性別',
    female: '女性',
    male: '男性',
    tall: '請問您的身高',
    cm: '公分',
    ft: '英呎',
    inch: '英吋',
    your_height: '身高',
    your_weight: '請問您的體重',
    weight: '體重',
    lbs: '磅',
    kg: '公斤',
    nickname: '您的姓名',
  },
  profile: {
    profile: '個人資料',
    edit_profile: '編輯個人資料',
    name: '姓名',
    birthday: '生日',
    birthyear: '出生年',
    phone: '電話號碼',
    email: '电子信箱',
    address: '地址',
    save: '確定',
  },
  discover: {
    head_title: '探索更多',
    check_my_size: '查看我的尺碼',
    rmd_size: '推薦尺碼',
    no_rmd_data: '沒有適合您的尺碼',
    no_rmd_items: '哎呀！目前無推薦的單品',
    buy_item: '購買',
  },
  discovery: {
    turn_on_bt: '開啟藍芽',
    turn_on_bt_hint: '請授權並啟用藍牙',
    turn_on_bt_hint_ios: '請確保以下設定皆有完成：<br>1. 授權權限<br>　● 前往「設定 > 隱私與安全性 > 藍牙」，開啟「雲衣適」權限<br>2. 啟用藍牙<br>　● 前往「設定 > 藍牙」，切換開關至「開啟」',
    turn_on_bt_hint_android: '請確保以下設定皆有完成：<br>1. 啟用藍牙<br>　● 從螢幕頂端向下滑動，輕觸「藍牙」圖示',
    searching: '掃描機搜尋中...',
    select_scanner: '請選擇您附近的裝置開始進行掃描',
    scanner__foot: '足部掃描機',
    scanner__body: '人體掃描機',
    start_scan: '開始 3D 掃描',
    no_scanners: "附近沒有偵測到任何掃描機",
    try_again: '再試一次',
    scanner_is_busy_title: '掃描機使用中',
    scanner_is_busy_desc: '請確認裡面是否有人正在使用掃描機。',
    scanner_is_busy_force_release: '立即掃描',
    scanner_is_busy_wait: '等待掃描完畢',
  },
  footscan: {
    take_off: '開始足部掃描，請先脫掉您的鞋子',
    barefoot: '脫掉襪子或是穿著合腳的襪子',
    show_ankles: '捲起褲管，露出您的腳踝',
    sit: '請坐在椅子上，膝蓋保持90度彎曲',
    stand_up: '請起立',
    position_feet: '請將雙腳踩定地上的標示',
    start_scan: '開始掃描',
    ready_to_scan: '準備好了!',
    stand_up_for_2nd_scan: '請起立並保持自然站姿，雙眼平視前方，進行掃描',
    stand_still: '保持自然站姿，雙眼平視前方',
    scan_complete: '掃描完成<br> 請放鬆身體',
    creating_3d_foot: '3Ｄ模型建立中...',
    scan_successful: '太好了！您的 3D 掃描結果十分成功！',
    click_to_rescan: '按下按鈕重新掃描',
    feet_3d: '3D 足部掃描',
    analysis: '足部分析',
    initial_l: '左',
    initial_r: '右',
    tab__fit: '鞋碼',
    tab__width: '足寬',
    tab__arches: '足弓',
    tab__measure: '尺寸',
    tab__type: '腳型',
    shoes_guide: '鞋子尺寸建議',
    shoes_last: '你的楦寬',
    measurement__ball: '腳掌圍',
    measurement__foot_length: '足長',
    measurement__foot_width: '足寬',
    measurement__instep: '腳背圍',
    measurement__span: '腳腰圍',
    measurement__arch: '足弓',
    measurement__finger_shape: '腳型',
    arch_type__title: '你的足弓高度',
    arch_type__high: '高足弓',
    arch_type__summary_high: '- 中足部分空凹較多，足底壓力集中在前腳掌與腳跟，腳部緩衝能力相對較弱，足弓無法為踏地時提供足夠的張力，容易外旋、穩定度不佳<br>' +
      '- 因腳掌接觸地面的範圍減少，較易長繭、疼痛，腳底韌帶緊繃及鞋跟外側嚴重磨損',
    arch_type__desc_high: '- 先天遺傳性的足底肌肉攣縮<br>' +
      '- 長期穿著過小、過緊或過窄的鞋子<br>' +
      '- 長時間穿著高跟鞋，造成重心前傾、腳跟不穩定、腳趾不易伸展、足背拱起<br>' +
      '<br>' +
      '保養與自療：<br>' +
      '- 若足底長期受力不均，容易引發足底筋膜炎<br>' +
      '- 足底筋膜伸展、按摩<br>' +
      '- 小腿肌肉伸展<br>' +
      '<br>' +
      '鞋款建議：<br>' +
      '吸震能力為首要考量，適合高緩衝、高避震性的鞋款及鞋墊<br>' +
      '鞋底硬度約在45度左右為佳，不宜太薄或太硬<br>' +
      '利用高足弓鞋墊有效支撐足弓，平均分散足底壓力，減少腿部衝擊',
    arch_type__normal: '正常足弓',
    arch_type__summary_normal: '恭喜你！你的足弓非常標準！',
    arch_type__desc_normal: '完美的足弓<br>' +
      '<br>' +
      '保養與自療：<br>' +
      '- 保持正常運動及體重<br>' +
      '<br>' +
      '鞋款建議：<br>' +
      '- 正常足弓的足底壓力受力均衡，可依照自己的需求和腳楦寬度等選擇適合自己的鞋型 <br>' +
      '可選擇一般穩定支撐及緩衝性佳的鞋款',
    arch_type__low: '低足弓',
    arch_type__summary_low: '- 足弓不明顯，腳掌接觸地面範圍較大，在踏地時內縱足弓消失，負荷會由內部邊緣承擔，而非前腳掌，導致足部不穩，鞋的內側較快磨損。<br>' +
      '- 久站或久走容易腳痠<br>' +
      '- 走路或跑步時較容易跌倒',
    arch_type__desc_low: '- 先天遺傳性的韌帶鬆弛、膝外翻、股骨前傾變形等現象<br>' +
      '- 足部外傷、骨折或類風濕性關節炎、足關節炎等後天性疾病<br>' +
      '- 體重過重加上穿鞋習慣姿勢錯誤造成<br>' +
      '<br>' +
      '保養與自療：<br>' +
      '- 足部肌力強化訓練，如墊腳尖、跳繩、走直線、腳趾抓毛巾等<br>' +
      '- 保持正常體重，避免增加雙腳負擔<br>' +
      '<br>' +
      '鞋款建議：<br>' +
      '- 穿著高支撐性足弓墊或鞋款，承托與固定足弓形狀，改善足弓下塌及防止足踝外翻<br>' +
      '- 適合寬鞋頭使腳掌有足夠的空間生長活動，後跟必須有堅挺的包覆，且鞋底要堅實、不宜太軟太硬<br>' +
      '- 扁平足的步態因內旋力量過大，容易造成小腿肌肉疲勞，因此在選鞋不能太軟 ，以免造成穩定度不佳引起足部疼痛，硬度約 40~60 度左右為佳',
    foot_type__title: '你的腳型',
    foot_type__egyptian: '埃及腳',
    foot_type__summary_egyptian: '大拇趾最長，其他四趾依序變短',
    foot_type__desc_egyptian: '埃及腳為最常見的腳型，因為腳趾依序排列俗稱 : 百搭腳型; <br>' +
      '非常適合穿圓頭鞋或斜頭鞋。<br>' +
      '但不適合穿著尖頭鞋，因最長的大拇趾容易受尖頭鞋的壓迫，造成拇指外翻<br>' +
      '<br>' +
      '鞋款建議：<br>' +
      '圓頭鞋、斜頭鞋',
    foot_type__roman: '羅馬腳',
    foot_type__summary_roman: '前三趾齊長，另外兩趾較短',
    foot_type__desc_roman: '- 極少數人擁有的腳型，也被稱作為芭蕾舞而生的腳型。<br>' +
      '- 羅馬腳外型呈現較方正，可選擇楦頭較寬的版型，如方頭鞋或圓頭鞋，避免擠腳。<br>' +
      '- 另外也可以選擇材質較軟的鞋款，減少腳趾被束縛的不適。<br>' +
      '<br>' +
      '鞋款建議：<br>' +
      '方頭鞋、圓頭鞋',
    foot_type__greek: '希臘腳',
    foot_type__summary_greek: '第二趾最長，腳板瘦長',
    foot_type__desc_greek: '- 擁有希臘腳型的人通常四肢修長，據說許多美女都符合希臘腳的特徵，有趣的是，紐約自由女神、希臘諸神雕像都是這種腳型。<br>' +
      '- 因前腳掌重心會集中在最細長的第二趾，非厚肥的大拇指，因此建議選擇有前掌海綿、彈力支撐的鞋款<br>' +
      '- 希臘腳的腳型是最能完美貼合尖頭鞋、高跟鞋鞋頭空間，因此最適合穿著尖頭鞋或高跟鞋<br>' +
      '<br>' +
      '鞋款建議：<br>' +
      '尖頭鞋、高跟鞋',
    foot_type__unknown: '未知',
    foot_type__summary_unknown: '未知',
    foot_type__desc_unknown: '未知',
  },
  mobileScan: {
    mobile_scan: '手機掃描',
    body_scanner: '人體掃描機',
    data_processing: '掃描資料處理中...',
    comeback_later: '稍候 5-10 分鐘再回來檢查您的 3D 模型',
    data_process_failed: '掃描失敗',
    error_not_inscreen: '你的全身從頭到腳沒有完整的出現在畫面中',
    error_messy_background: '背景太雜亂',
    device_unsupported: '糟糕！<br>您的設備目前並不支援3D 手機掃描功能',
    need_faceid: '目前 3D 手機掃描只適用於 iPhone X 或更新款具有Face ID功能的機型',
    scanner_name: '3D 手機掃描',
    confirm_info: '請確認您的個人資料',
    begin_title: '準備開始',
    begin_info: '請穿著貼身衣物<br>束起長髮，露出脖子',
    start_tutorial: '開始教學',
    not_first: '已經操作過手機掃描了？',
    skip_tutorial: '跳過教學',
    vertical_info: '將手機<br>以 90° 的角度<br>直立於平面',
    inscreen_info: '確保全身<br>從頭到腳都完整的<br>出現在畫面中',
    backoff_info: '按下一步後，<br>請在 10 秒內<br>回到原位',
    spin_info: '掃描時，請將雙手握拳、<br>手臂張開，並在十秒內<br>原地360度的旋轉一圈',
    check_title: '準備開始掃描',
    check_info: '請檢查並勾選是否符合下列指示',
    wear_tight: '請穿著貼身衣物、<br>束起長髮並露出脖子',
    wipe_front: '請擦拭前鏡頭',
    volume_up: '調高手機音量',
    next: '下一步',
    start_scan: '開始掃描',
    starting_in: '即將開始',
    preview_info: '請檢查你的掃描數據是否符合下列指示並勾選確認',
    preview_inscreen: '全身入鏡於畫面中',
    preview_arms_open: '手臂張開，雙手握拳',
    preview_spin: '原地旋轉 360°',
    preview_delete: '模型生成之後，影片將被刪除',
    rescan: '重新掃描',
    uploading: '掃描數據處理中...<br>請勿關閉視窗',
    uploading_done: '分析完成！<br>請稍候 5-10 分鐘再回來檢查您的 3D 人體模型',
    finish_btn: '完成',
    upload_error: '店家的人體掃描功能尚未開啟，請聯繫店家服務人員',
    no_balance: '店家人體掃描功能已暫停，請聯繫店家服務人員',
    scan_limit_reached: '您已超過店家設定的本月掃描次數',
    leave: '離開',
    no_credits: '您沒有足夠的手機掃描點數',
    no_email: "您還沒有填寫Email",
    credits: '手機掃描點數',
    purchase: '購買點數',
    purchase_cart: '我的購物車',
    purchase_total: '總計',
    purchase_item: '項目',
    purchase_checkout: '結帳',
    purchase_reminder: '我們將會寄送付款收據至您的電子郵件信箱。',
    payment_succeed: '恭喜! \n您的訂單已成立',
    payment_succeed_des: '我們將會寄送信件至您的電子郵件信箱，\n請至您的電子信箱確認訂單詳細內容',
    update_email: '填寫 Email'
  },
  mobileScan2: {
    inscreen_front_info: '拍正面照<br>請確認全身入鏡<br>雙手雙腳微微張開',
    inscreen_side_info: '拍側面照<br>請原地向左轉<br>雙腳併攏雙手貼緊大腿外側',
    inscreen_info: '確認全身完整顯示在畫面之中',
    trun_left_info: '請向左轉，雙腳併攏，雙手貼緊大腿外側',
  },
  share: {
    voucher_expired: '連線過期，請重新啟動頁面',
    no_scan_data: '尚未有掃描資料',
  },
};
